<template>
	<div class="header">
		<div class="section-action">
			<UiButtonMenu
				class="btn__menu"
				@click="openSideBar"
			/>
		</div>
		<!-- <HeaderConnectionStatus /> -->
		<div class="header__wrapper">
			<div class="section-info">
				<!-- <Logo
				class="logo"
				variant-logo="header"
				heightLogo="35px"
				width-logo="110px"
			/> -->
				<!-- {{ driverHeaderInfoComputed }} -->
				<div class="card__info-driver">
					<UiIcon
						name="profile-circle"
						folder="profile"
						width="24px"
						color="var(--white)"
					/>
					<div class="content">
						<TypographyKTypographyBody6
							class="title"
							color="#D4D4DD"
							>{{ 'Водитель' }}</TypographyKTypographyBody6
						>
						<TypographyKTypographyBody5
							class="subtitle"
							color="var(--white)"
							>{{ driverHeaderInfoComputed?.name }}</TypographyKTypographyBody5
						>
					</div>
				</div>
				<div class="card__info-driver">
					<UiIcon
						name="cargo"
						folder="profile"
						width="24px"
						color="var(--white)"
					/>
					<div class="content">
						<TypographyKTypographyBody6
							class="title"
							color="#D4D4DD"
							>{{ 'Транспорт' }}</TypographyKTypographyBody6
						>
						<TypographyKTypographyBody5
							class="subtitle"
							color="var(--white)"
							>{{ driverHeaderInfoComputed?.car }}</TypographyKTypographyBody5
						>
					</div>
				</div>
			</div>
			<div class="section-cargos">
				<div class="cargos">
					<div
						v-for="status in pickupStatuses"
						:key="status.id"
						class="cargo"
						:class="{ cargo__active: status.driverFilter === currentFilterType }"
						:style="{
							color: status.driverFilter === currentFilterType ? status.backgroundColor : 'var(--black)'
						}"
						@click="setFilterTypeCargo(status.driverFilter)"
					>
						<div class="cargo__icon-wrapper">
							<UiIcon
								:name="status.variableName"
								folder="cargos"
								:color="status.driverFilter === currentFilterType ? status?.backgroundColor : 'var(--black)'"
								v-if="status.variableName"
							/>
							<TypographyKTypographyBody5
								:color="status?.backgroundColor"
								font-type="semi-bold"
							>
								({{ driverHeaderInfoComputed?.[status.variableName] || 0 }})
							</TypographyKTypographyBody5>
						</div>

						<TypographyKTypographyBody4 class="cargo__title">
							{{ status?.name }}
						</TypographyKTypographyBody4>
					</div>
				</div>
				<div class="block-date">
					<UiDatePicker
						v-model="chooseDate"
						:date-picker-unique-id="'date-picker-wrapper-week-start'"
						#default="{ isOpen }"
						@chooseDate="chooseDateForGetCargo"
					>
						<UiIcon
							name="calendar"
							color="#fff"
							additional-color="#fff"
						/>
					</UiDatePicker>
					<TypographyKTypographyBody4
						color="var(--white)"
						font-type="semi-bold"
					>
						{{ getCurrentDate }}
					</TypographyKTypographyBody4>
				</div>
			</div>
		</div>
	</div>
	<SideBar
		v-if="isSideBarOpen"
		@closeSideBar="closeSideBar"
		@openSupportChat="openSupportChat"
	/>
</template>

<script setup lang="ts">
	import { getDateInLocaleString } from '~/helpers/date';
	import { useDictionariesStore } from '~/store/dictionaries.store';
	import { useDriverRequestStore } from '~/store/driverRequests.store';

	const emits = defineEmits(['openSupportChat']);
	const isSideBarOpen = ref(false);
	const driverRequestsStore = useDriverRequestStore();
	const { getPickupStatuses } = useDictionariesStore();
	const driverHeaderInfoComputed = computed(() => driverRequestsStore.driverHeaderInfo);
	const pageReqInterval = ref<NodeJS.Timeout | null>(null);
	const isToday = computed(() => {
		const selectedDate = new Date(chooseDate.value);
		const today = new Date();

		const isToday =
			selectedDate.getDate() === today.getDate() &&
			selectedDate.getMonth() === today.getMonth() &&
			selectedDate.getFullYear() === today.getFullYear();

		return isToday;
	});
	const getCurrentDate = computed(() => {
		if (isToday.value) {
			return 'Сегодня';
		}
		return getDateInLocaleString(chooseDate.value, { showTime: false, year: 'numeric' });
	});
	const currentFilterType = computed(() => driverRequestsStore.filterDriverRequestsType);
	const pickupStatuses = computed(() => {
		return Array.from(useDictionariesStore().pickupStatuses?.values() || []).filter((s) => s?.visible);
	});

	const chooseDate = storeToRefs(driverRequestsStore).chooseDate;

	const chooseDateForGetCargo = () => {
		driverRequestsStore.getDriverRequests(true);
		driverRequestsStore.getHeaderInfo();
	};

	const setFilterTypeCargo = (type: number) => {
		if (currentFilterType.value === type) {
			driverRequestsStore.setFilterDriverRequestsType(null);
		} else {
			driverRequestsStore.setFilterDriverRequestsType(type);
		}

		driverRequestsStore.getDriverRequests(true);
	};

	const getHeaderInfo = async () => {
		await driverRequestsStore.getHeaderInfo();
	};

	const openSideBar = () => {
		isSideBarOpen.value = true;
	};

	const closeSideBar = () => {
		isSideBarOpen.value = false;
	};

	const openSupportChat = () => {
		emits('openSupportChat', '');
	};

	getHeaderInfo();
	getPickupStatuses();

	onMounted(() => {
		const startInterval = async () => {
			pageReqInterval.value = setTimeout(async () => {
				await getHeaderInfo();
				if (pageReqInterval.value) startInterval();
			}, 20000);
		};
		startInterval();
	});

	onUnmounted(() => {
		if (pageReqInterval.value) {
			clearTimeout(pageReqInterval.value);
			pageReqInterval.value = null;
		}
	});
</script>

<style scoped lang="scss">
	.cargos {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		gap: 8px;

		.cargo {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: 4px;
			background-color: var(--white);
			border-radius: 16px;
			padding: 2px 4px;
			height: 64px;
			cursor: pointer;

			&__icon-wrapper {
				display: flex;
				align-items: center;
				gap: 5px;
			}

			&__title {
				display: flex;
				white-space: nowrap;
				gap: 5px;
			}

			.count {
			}

			&__active {
				border: 1.8px solid; /* резервируем место, если нужно */
				box-shadow: inset 0 0 0 2.5px #264688; /* внутренняя обводка */
			}
		}
	}
	.header {
		display: flex;
		flex-direction: column;
		gap: 20px;
		justify-content: center;
		align-items: center;
		background-color: transparent;
		padding: 20px 0px 0px 0px;
		width: 100%;

		&__wrapper {
			display: flex;
			flex-direction: column;
			width: 100%;
			max-width: 800px;
		}

		.section-cargos {
			display: flex;
			flex-direction: column;
			gap: 14px;
			width: 100%;
			margin-top: 16px;

			.block-date {
				display: flex;
				gap: 10px;
				align-items: center;
			}
		}

		.section-info {
			display: flex;
			align-items: center;
			width: 100%;

			.card__info-driver {
				display: flex;
				align-items: center;
				gap: 10px;
				width: 100%;
				background: linear-gradient(90deg, rgba(239, 242, 246, 0.28) 40%, rgba(185, 177, 228, 0.28) 100%);
				min-height: 40px;
				max-height: 40px;
				border-radius: 12px;
				margin-right: 11px;
				padding: 8px;

				.content {
					display: flex;
					flex-direction: column;
					gap: 3px;
					justify-content: center;
					overflow: hidden;
				}

				&:last-child {
					margin-right: 0px;
				}
			}
		}

		.section-action {
			display: flex;
			align-items: center;
			margin-left: auto;
			margin-bottom: 10px;

			.btn__menu {
				margin-left: 25px;
			}
		}

		@media (max-width: $extra-sm) {
			//padding: 20px 15px;
		}
	}
</style>
